import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "font-bold text-xl mb-4" }
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = { class: "flex justify-between flex-col md:flex-row pt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NextButton = _resolveComponent("NextButton")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    visible: _ctx.visible,
    "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.visible) = $event))
  }, {
    header: _withCtx(() => [
      _createElementVNode("h2", _hoisted_1, [
        _renderSlot(_ctx.$slots, "title", {}, () => [
          _cache[4] || (_cache[4] = _createTextVNode("Apporvazione azienda"))
        ])
      ])
    ]),
    main: _withCtx(() => [
      _createElementVNode("p", _hoisted_2, [
        _renderSlot(_ctx.$slots, "content", {}, () => [
          _cache[5] || (_cache[5] = _createTextVNode("Desideri approvare o rifiutare l'azienda?"))
        ])
      ]),
      _withDirectives(_createElementVNode("p", { class: "mb-4 text-next-orange" }, _toDisplayString(_ctx.error), 513), [
        [_vShow, _ctx.error]
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_NextButton, {
          variant: "primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('approva'))),
          class: "py-2 px-4 mb-3 md:mb-0"
        }, {
          default: _withCtx(() => _cache[6] || (_cache[6] = [
            _createTextVNode(" Approva ")
          ])),
          _: 1
        }),
        _createVNode(_component_NextButton, {
          variant: "primary",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('rifiuta'))),
          class: "py-2 px-4 mb-3 md:mb-0"
        }, {
          default: _withCtx(() => _cache[7] || (_cache[7] = [
            _createTextVNode(" Rifiuta ")
          ])),
          _: 1
        }),
        _createVNode(_component_NextButton, {
          variant: "outline-secondary",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:visible', false))),
          class: "py-2 px-4"
        }, {
          default: _withCtx(() => _cache[8] || (_cache[8] = [
            _createTextVNode(" Chiudi ")
          ])),
          _: 1
        })
      ])
    ]),
    _: 3
  }, 8, ["visible"]))
}